let welcome_jars = document.querySelectorAll('.welcome-jar') || false; 
let welcome_jars_containers =  document.querySelectorAll ('.jars-container');
let bundle_product = welcome_jars_containers.length > 1 ? true : false;
console_log("🚀 ~ bundle_product:", bundle_product);
// let jarQuantity = document.querySelectorAll('.jar__quantity') || false;


// const clearJars = () => {
//   document.querySelectorAll('.welcome-jar input').forEach(el => el.value = 0);
//   document.querySelectorAll('.welcome-jar').forEach(el => el.classList.remove('active'));
//   getSelectedJar();
// }

// const getCurrentJarsQuantity = () => {
//   let activeJars = document.querySelectorAll('.welcome-jar.active input');
//   let curJarsQty = 0;
//   activeJars.forEach(el => curJarsQty += +el.value );

//   return curJarsQty;
// }


// const canAddMoreJars = () => {
//   let jarsMaxQty = calcMaxQuantity();
//   let curJarsQty = getCurrentJarsQuantity();

//   console_log(curJarsQty < jarsMaxQty, curJarsQty, jarsMaxQty);
//   return curJarsQty < jarsMaxQty;
// }

// const adjustQuantity = event => {
//   event.stopImmediatePropagation();
//   let currentParent = event.target.closest('.jar__quantity');
//   let currentInput = currentParent.querySelector('input');
//   let jarsMaxQty = calcMaxQuantity();
//   let curJarsQty = getCurrentJarsQuantity();
  
  
//   if ( event.target.closest('.quantity__button[name="minus"]') ){
//     if (currentInput.value != 0)  {
//       currentInput.value = +currentInput.value - 1;
//       if (currentInput.value == 0) currentParent.closest('.welcome-jar').classList.remove('active');
//     }
//   } else if ( event.target.closest('.quantity__button[name="plus"]') ){
//     if (currentInput.value < jarsMaxQty && curJarsQty < jarsMaxQty) currentInput.value = +currentInput.value + 1;
//   }

//   getSelectedJar();
// }
  

// if (jarQuantity.length > 0) {
//   jarQuantity.forEach(el => el.addEventListener('click', adjustQuantity));
//   document.body.addEventListener('productVariantUpdated', clearJars);
// }

const calcMaxQuantity = () => {
  let jarsLimits = JSON.parse(document.getElementById('bundle-jars-limits').textContent);
  let currentVariantId = document.querySelector('#main-prodct-form [name="id"]').value;
  let jarsMaxQty;

  for (const [key, value] of Object.entries(jarsLimits)) {
    if (key == currentVariantId) jarsMaxQty = value;
  }

  return jarsMaxQty;
}


const toggleGalleryJar = jar_id => {
  let gallery_jar_imgs = document.querySelectorAll('.welcome-jar__image');

  gallery_jar_imgs.forEach(el => {
    el.dataset.variantId == jar_id ? el.classList.add('active') : el.classList.remove('active');
  });
}

const toggleActiveJar = event => {
  let targetJar = event.target.closest('.welcome-jar');
  let jarParent = targetJar.closest('.welcome-jars');

  jarParent.querySelector('.welcome-jar.active').classList.remove('active');
  targetJar.classList.add('active');
  
  // else {
  //   // Bundles
  //   if (event.target.closest('.welcome-jar-empty')) {
  //     // Clear all click
  //     document.querySelectorAll('.welcome-jar:not(.welcome-jar-empty)').forEach(el => { 
  //       // Delete qty when ALL jars deselected
  //       el.classList.remove('active');
  //       el.querySelector('input').value = 0;
  //     });
  //     event.target.closest('.welcome-jar-empty').classList.add('active');
  //   } else {
  //     // always deselect Empty jar
  //     document.querySelector('.welcome-jar-empty').classList.remove('active');
  //     // Jar click
  //     if (targetJar.classList.contains('active')) {
  //       targetJar.querySelector('input').value = 0;
  //     }else{
  //       if (canAddMoreJars()) targetJar.querySelector('input').value = 1;
  //     }

  //     targetJar.classList.toggle('active');
  //   }
  // }
  
  getSelectedJar();
}

const getSelectedJar = () => {
  let jars = [];
  let curent_jar = document.querySelector('.welcome-jar.active');

  if (!bundle_product) {
    if (curent_jar.dataset.variantId != undefined) {
      jars.push(curent_jar.dataset.variantId);
    }
  
    toggleGalleryJar(jars[0]);
  }else {
    document.querySelectorAll('.jars-container:not(.hidden)').forEach(el => {
      jars.push(el.querySelector('.welcome-jar.active').dataset.variantId);
    });
  }


 
  // else {
  //   // Bundle
  //   document.querySelectorAll('.welcome-jar.active .quantity__input').forEach(jar => {
  //     if (jar.dataset.jarId != undefined) {
  //       for (let i = 0; i < parseInt(jar.value); i++) {
  //         jars += `${jar.dataset.jarId},`;
  //       }
  //     }
  //   });
  //   console_log(jars)
  // }

  updateWelcomekitProperty(jars);
}

const updateWelcomekitProperty = (jars) => {
    let product_form = document.querySelector('#main-prodct-form .product-form form');
    if (product_form.querySelector('#welcome_kit')) product_form.querySelector('#welcome_kit').remove()
    if (!jars) return;


    if (jars && product_form) {
      product_form.insertAdjacentHTML('afterbegin', `<input id="welcome_kit" type="hidden" name="properties[_welcome_kit]" value="${jars.join(',')}">`);
    }
}

welcome_jars && welcome_jars.forEach(jar => jar.addEventListener('click', toggleActiveJar));

if (bundle_product) {
  document.body.addEventListener('productVariantUpdated', () => {
    let maxQty = calcMaxQuantity();

    welcome_jars_containers.forEach((container, index) => {
      index < maxQty ? container.classList.remove('hidden') : container.classList.add('hidden');
    });

    getSelectedJar();
  });
}